<template>
    <div class="unsubscribe">
        <customModalDialog :settings="customModalSettings"></customModalDialog>
        <div class="dropdown-content">
            <ul>
                <li class="item">
                    <div class="item__wrapper">
                        <div class="title">
                            <div class="title__wrapper">
                                <img src="@/assets/icons/alert_settings_icon.svg" class="alert__image">
                                <div class="notification__content">
                                    <h3>
                                        <span>{{translate('Notifications')}}</span>
                                    </h3>
                                    <div class="notification__wrapper">
                                        <span class="description">{{translate('receiveBadVotesViaSms')}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <transition name="component-fade" mode="out-in">
                            <div class="content">
                                <div class="notificationBtn">
                                    <input type="checkbox" id="notificationBtn" class="notificationBtn__checkbox"
                                           @click="profile.disableNotifications = !profile.disableNotifications"
                                           v-model="profile.disableNotifications">
                                    <label for="notificationBtn" id="notificationBtn__text" class="notificationBtn__text">{{translate('DisableAllNotifications')}}</label>
                                </div>
                                <div class="grid notification-section" :class="{'disable-notification': profile.disableNotifications}">
                                    <div class="report-title__wrapper">
                                        <div class="report-title">{{translate('Channel')}}</div>
                                    </div>
                                    <div class="active-field">
                                        <b-form-checkbox v-model="profile.checkboxSms">
                                            <span>{{translate('SMS')}}</span>
                                        </b-form-checkbox>
                                        <b-form-checkbox v-model="profile.checkboxEmail">
                                            <span>{{translate('Email')}}</span>
                                        </b-form-checkbox>
                                    </div>
                                    <div class="alert-title__wrapper">
                                        <div class="report-title">{{translate('sendAlertEvery')}}</div>
                                    </div>
                                    <div class="active-field">
                                        <div class="active-field__wrapper">
                                            <div class="input__wrapper">
                                                <input class="active-field__number active" min="0" v-model="profile.SendNotificationEach"
                                                       @input="profile.SendNotificationEach < 0 ? profile.SendNotificationEach = 0 : null">
                                                <span>{{translate('SendNotificationEach2')}}</span>
                                            </div>
                                            <div class="active-field__checkbox-list">
                                                <b-form-checkbox v-model="profile.checkboxHappy">
                                                    <span>"{{translate('checkboxHappy')}}"</span>
                                                </b-form-checkbox>
                                                <b-form-checkbox v-model="profile.checkboxSoSo">
                                                    <span>"{{translate('checkboxSoSo')}}"</span>
                                                </b-form-checkbox>
                                                <b-form-checkbox v-model="profile.checkboxSad">
                                                    <span>"{{translate('checkboxSad')}}"</span>
                                                </b-form-checkbox>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="additional_checkboxes">
                                        <b-form-checkbox v-model="profile.detailsOnly" @input="onWithDetailsOnlyClick">
                                            <span>{{translate('WithDetailsOnly')}}</span>
                                        </b-form-checkbox>
                                        <div class="active-field__checkbox-list" v-if="profile.detailsOnly">
                                            <b-form-checkbox v-model="profile.commentOnly">
                                                <span>{{translate('WithCommentsOnly')}}</span>
                                            </b-form-checkbox>
                                            <b-form-checkbox v-model="profile.sldOnly">
                                                <span>{{translate('WithSldOnly')}}</span>
                                            </b-form-checkbox>
                                        </div>
                                    </div>
                                    <div class="blocks-divider"></div>
                                    <div class="additional_checkboxes">
                                        <b-form-checkbox v-model="profile.checkboxServiceLog">
                                            <span>Service log alerts</span>
                                        </b-form-checkbox>
                                        <b-form-checkbox v-model="profile.checkboxDumpsters" v-if="profile.checkboxDumpstersShow">
                                            <span>Dumpster alerts</span>
                                        </b-form-checkbox>
                                        <b-form-checkbox v-model="profile.checkboxGreasetraps" v-if="profile.checkboxGreasetrapsShow">
                                            <span>Greasetrap alerts</span>
                                        </b-form-checkbox>
                                        <b-form-checkbox v-model="profile.checkboxGoogleReviewAlerts" v-if="profile.checkboxGoogleReviewAlertsShow">
                                            <span>{{translate('settings_checkbox_GoogleReviewAlerts')}}</span>
                                        </b-form-checkbox>
                                    </div>
                                </div>
                            </div>
                        </transition>
                    </div>
                </li>
                <li class="item">
                    <div class="item__wrapper">
                        <div class="title">
                            <div class="title__wrapper">
                                <img src="@/assets/icons/report_settings_icon.svg" class="report__image">
                                <div>
                                    <h3>
                                        <span>{{translate('Reports')}}</span>
                                    </h3>
                                    <span class="description">{{translate('sendDetailedReportToEmail')}}</span>
                                </div>
                            </div>
                        </div>
                        <transition name="component-fade" mode="out-in">
                            <div class="report-content">
                                <div class="grid notification-section">
                                    <div>
                                        <div class="report-title">{{translate('Regularity')}}</div>
                                    </div>
                                    <div class="active-field">
                                        <label>
                                            <b-form-checkbox v-model="profile.dailyReports">
                                                <span>{{translate('daily')}}</span>
                                            </b-form-checkbox>
                                        </label>
                                        <label>
                                            <b-form-checkbox v-model="profile.weeklyReports">
                                                <span>{{translate('weekly')}}</span>
                                            </b-form-checkbox>
                                        </label>
                                        <label>
                                            <b-form-checkbox v-model="profile.monthlyReports">
                                                <span>{{translate('monthly')}}</span>
                                            </b-form-checkbox>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </transition>
                    </div>
                </li>
            </ul>
            <div class="item-btn">
                <div class="item-btn__wrapper">
                    <div class="content__save-btn" @click="updateUnsubscribeProfileReports(true, true)">
                        {{translate('unsubscribeSaveBtn')}}
                    </div>
                    <div class="content__unsubscribe-btn" @click="unsubscribeAction">
                        {{translate('unsubscribeBtn')}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapMutations} from "vuex";
    import customModalDialog from '@/components/widgets/customModalDialog';
    import logAnalyticsEvent, {logError} from '@/helpers/analytics';
    import errorMixin from "@/mixins/errorMixin";

    export default {
        mixins: [errorMixin],
        name: "unsubscribeFlow",

        data() {
            return {
                profile: {
                    commentOnly: false,
                    sldOnly: false,
                    detailsOnly: false,
                    checkboxSms: false,
                    checkboxEmail: false,
                    checkboxHappy: false,
                    checkboxSad: false,
                    checkboxSoSo: false,
                    checkboxServiceLog: false,
                    checkboxDumpsters: false,
                    checkboxDumpstersShow: false,
                    checkboxGreasetraps: false,
                    checkboxGreasetrapsShow: false,
                    checkboxGoogleReviewAlerts: false,
                    checkboxGoogleReviewAlertsShow: false,
                    disableNotifications: true,
                    SendNotificationEach: 0,
                    dailyReports: false,
                    weeklyReports: false,
                    monthlyReports: false,
                    showZeroVotes: false,
                },
                customModalSettings: {},
                unsubscribeInfo: {},
            }
        },
        components: {
            customModalDialog
        },
        async beforeMount() {
            await this.getProfileInfo()
        },
        methods: {
            ...mapActions({
                fetchUnsubscribeUserInfo: 'auth/fetchUnsubscribeUserInfo',
                updateUnsubscribeProfileAction: 'auth/updateUnsubscribeProfile'
            }),
            ...mapMutations({
                setMessageModel: 'setMessageModel'
            }),

            setDefaultSettingsBeforeUnsubscribe() {
                this.profile.checkboxEmail = true
                this.profile.checkboxHappy = true
                this.profile.checkboxSad = true
                this.profile.checkboxSoSo = true
                this.profile.commentOnly = true
                this.profile.SendNotificationEach = 1
            },

            async getProfileInfo () {
                try {
                   const response = await this.fetchUnsubscribeUserInfo({
                       user_uid: this.getUserGuid(),
                       token: this.getToken()
                   })
                    this.unsubscribeInfo = response.data.profile
                    this.profile.checkboxSms = this.unsubscribeInfo.setups.notifications.channels.includes('sms')
                    this.profile.checkboxEmail = this.unsubscribeInfo.setups.notifications.channels.includes('email')
                    this.profile.checkboxHappy = this.unsubscribeInfo.setups.notifications.notified_votes.includes('happy')
                    this.profile.checkboxSoSo = this.unsubscribeInfo.setups.notifications.notified_votes.includes('ok') //todo then soso_votes3
                    this.profile.checkboxSad = this.unsubscribeInfo.setups.notifications.notified_votes.includes('sad')
                    this.profile.checkboxServiceLog = this.unsubscribeInfo.setups.notifications.notified_votes.includes('service_log')
                    this.profile.checkboxDumpsters = this.unsubscribeInfo.setups.notifications.notified_votes.includes('dumpsters')
                    this.profile.checkboxGreasetraps = this.unsubscribeInfo.setups.notifications.notified_votes.includes('greasetraps')
                    this.profile.checkboxDumpstersShow = this.unsubscribeInfo.setups.notifications.notify_dumpsters_show
                    this.profile.checkboxGreasetrapsShow = this.unsubscribeInfo.setups.notifications.notify_greasetraps_show
                    this.profile.checkboxGoogleReviewAlerts = this.unsubscribeInfo.setups.notifications.notified_votes.includes('google_reviews')
                    this.profile.checkboxGoogleReviewAlertsShow = this.unsubscribeInfo.setups.notifications.notify_google_reviews_show
                    this.profile.commentOnly = this.unsubscribeInfo.setups.notifications.any_commented // any_commented
                    this.profile.sldOnly = this.unsubscribeInfo.setups.notifications.only_sld // any_commented
                    this.profile.detailsOnly = this.profile.commentOnly || this.profile.sldOnly
                    this.profile.SendNotificationEach = this.unsubscribeInfo.setups.notifications.vote_count
                    this.profile.disableNotifications = !this.unsubscribeInfo.setups.notifications.enabled
                    this.profile.dailyReports = this.unsubscribeInfo.setups.reports.daily_reports
                    this.profile.weeklyReports = this.unsubscribeInfo.setups.reports.weekly_reports
                    this.profile.monthlyReports = this.unsubscribeInfo.setups.reports.monthly_reports

                } catch (e) {
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                }

            },
            getToken () {
                return this.$route.query.token
            },
            getUserGuid () {
               return  this.$route.params.user_guid
            },
            async updateUnsubscribeProfile (body, showSuccess = true) {
                try {
                    const response = await this.updateUnsubscribeProfileAction({
                        body: body,
                        user_uid: this.getUserGuid(),
                        token: this.getToken(),
                        })
                    if(showSuccess) {
                        this.setMessageModel({
                            msg: this.translate('savedSuccessfuly'),
                            duration: 1000
                        })
                    }
                } catch (e) {
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                    throw e
                }
            },
            async updateUnsubscribeProfileReports(showSuccess = true, isUpdate = false) {
                const body = {
                    setups: {
                        notifications: {
                            enabled: !this.profile.disableNotifications,
                            any_commented: this.profile.commentOnly,
                            only_sld: this.profile.sldOnly,
                            vote_count: parseInt(this.profile.SendNotificationEach),
                            show_zero_votes: this.profile.showZeroVotes,
                        },
                        reports: {
                            daily_reports: this.profile.dailyReports,
                            weekly_reports: this.profile.weeklyReports,
                            monthly_reports: this.profile.monthlyReports
                        },
                    },
                    is_update: isUpdate,
                }
                let channelsData = {
                    'sms': this.profile.checkboxSms,
                    'email': this.profile.checkboxEmail

                }
                body.setups.notifications.channels = this.createSettingsArray(channelsData)
                let notifiedData = {
                    'happy': this.profile.checkboxHappy,
                    'ok': this.profile.checkboxSoSo,
                    'sad': this.profile.checkboxSad,
                }
                body.setups.notifications.notified_votes = this.createSettingsArray(notifiedData)
                try {
                    await this.updateUnsubscribeProfile(body, showSuccess)
                    logAnalyticsEvent(`settings_save_report_success`)
                } catch (e) {
                    logError('settings_save_report_error', e.data.error.message || '')
                }
            },
            async unsubscribeAction () {
                this.profile.disableNotifications = true
                this.profile.dailyReports = false
                this.profile.weeklyReports = false
                this.profile.monthlyReports = false
                try {
                    await this.updateUnsubscribeProfileReports(false, false)
                    this.customModalSettings = {
                        icon: 'ic_allow.svg',
                        message: this.translate('unsubscribePopupText'),
                        okButtonText: this.translate('Close'),
                    }
                    logAnalyticsEvent(`settings_save_report_success`)
                } catch (e) {
                    logError('settings_save_report_error', e.data.error.message || '')
                }
            },
            createSettingsArray(data) {
                let settings = []
                for (const [key, value] of Object.entries(data)) {
                    if(value) settings.push(key)
                }
                return settings
            },
            onWithDetailsOnlyClick() {
                if(this.profile.detailsOnly) {
                    this.profile.sldOnly = true
                    this.profile.commentOnly = true
                } else {
                    this.profile.sldOnly = false
                    this.profile.commentOnly = false
                }
            },


        }
    }
</script>

<style scoped>
    .unsubscribe {
        background: #F3F3F3;
        padding: 70px;
    }
    .dropdown-content .item {
        margin: 0 0 24px;
        width: 100%;
        -webkit-box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.11);
        box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.11);
        position: relative;
    }
    .item__wrapper {
        border-radius: 4px;
        background-color: #FFFFFF;
        padding: 0px 30px 18px;
    }
    .dropdown-content .item .title img {
        margin-right: 17px;
    }
    .dropdown-content .grid {
        display: flex;
        flex-direction: column;
        margin-top: 10px;
    }

    .dropdown-content .grid div,
    .dropdown-content .grid div a {
        color: #2F2F2F;
        font-size: 14px;
        line-height: 22px;
    }

    .dropdown-content .grid div:nth-child(odd) {
        font-weight: 700;
        margin-right: 27px;
    }
    .title__wrapper {
        display: flex;
        align-items: baseline;
    }
    .alert__image {
        margin-bottom: 22px;
    }
    .alert-title__wrapper {
        margin-top: 19px;
    }
    h3 {
        margin-top: 25px;
    }
    .notification-section > div {
        display: flex;
        align-items: center;
    }

    .notification-section > div:nth-child(odd) span,
    .notification-section > div:nth-child(even) label {
        color: #2F2F2F;
        font-size: 14px;
        line-height: 22px;
    }

    .notification-section > div:nth-child(odd) span {
        font-style: normal;
        font-weight: 600 !important;
        font-size: 15px;
        line-height: 20px;
        padding-left: 4px;
    }

    .notification-section > div:nth-child(even) label {
        margin-bottom: 0;
        margin-right: 19px;
    }

    .notification-section > div:nth-child(even) label span {
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        font-family: Nunito;
        padding-left: 5px;
    }
    .active-field__number {
        font-size: 14px;
        max-width: 25px;
        background: none;
        border: 0;
        outline: none!important;
        margin-bottom: 8px;
    }
    .active-field__number.active {
        border-bottom: 2px solid #3F405C;
        max-width: 45px;
    }
    .active-field__checkbox-list {
        margin-left: 20px;
    }
    .active-field__comment {
        margin-top: 5px;
    }
    .report-content {
        margin-left: 36px;
        margin-top: 23px;
    }
    .item-btn {
        background: #F3F3F3;
        height: 96px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .item-btn__wrapper {
        display: flex;
        align-items: center;
    }
    .content__save-btn {
        background-color: #3F405C;
        padding: 12px 54px;
        margin-right: 63px;
        font-family: Nunito;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        color: #ffffff;
        border-radius: 6px;
        cursor: pointer;
    }
    .content__unsubscribe-btn {
        font-family: Nunito;
        cursor: pointer;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        color: #3F405C;
    }
    .disable-notification {
        opacity: .5;
        cursor: no-drop;
    }
    .additional_checkboxes {
        display: flex !important;
        flex-direction: column;
        align-items: flex-start !important;
    }
    .blocks-divider {
        width: 100%;
        height: 1px;
        background: rgba(199, 199, 199, 0.5);
        margin-top: 10px;
        margin-bottom: 10px;
    }
    @media screen and (max-width: 765px) {
        .dropdown-content .grid div {
            display: inline-block;
        }
        .item-btn {
            height: auto;
        }
        .item-btn__wrapper {
            margin-top: 25px;
            margin-bottom: 25px;
            width: 100%;
            flex-direction: column;
            margin-left: 0;
            justify-content: center;
            align-items: center;
        }
        .content__save-btn {
            margin-right: 0;
            margin-bottom: 25px;
        }
    }

    @media screen and (max-width: 426px) {
        .content__save-btn {
            padding: 12px 30px;
        }
        .item-btn__wrapper {
            margin-right: 15px;
            margin-left: 15px;
        }
        .unsubscribe {
            padding: 20px;
        }
    }

    @media  screen and (max-width: 321px ) {
        .content__save-btn {
            padding: 12px 10px;
        }
    }


</style>
